export * from "./MovieDetailCard";
